import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Button from "components/CustomButtons/Button.jsx";

import withMobileDialog from "@material-ui/core/withMobileDialog";

import TokenUtilizationTable from "./TokenUtilizationTable.jsx";
import SearchPanel from "./SearchPanel.jsx";

import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import { connect } from "react-redux";
import { store } from "../../_store";
import { alertActions, commonActions } from "../../_actions";
import { commonService } from "../../_services";
import { appConstants } from "../../_constants";
import CircularProgress from "../../utils/CircularProgress";
import moment from "moment/moment";
import { EmptyRecord } from "../../utils/PageUtility";
import DownloadIcon from "@material-ui/icons/CloudDownload";
import { SummaryCard } from "./SummaryCard";
import { appHelpers } from "../../_helpers/index.js";


class PSCUtilization extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedMonth: "",
            open: false,
            selectedMonthValue: "",
            selectedAirlineValue: "",
            selectedAirportValue: "",
            airlines: [],
            airports: [],
            AirlineId: '-1',
            AirportId: '-1',
            currentPage: 1,
            pageSize: 10,
            totalCounts: 0,
            records: [],
            pageRequesting: true,
            From: 0,
            TotalPassengers: 0,
            TotalBillablePassengers: 0,
            TotalPscTokenUtilized: 0,
            TotalOutstandingBillablePassengers: 0,
        };
    }

    componentDidMount() {
        let { airlines, airports, user } = store.getState();
        const { dispatch } = this.props;
        if (airlines) {
            this.setState({ airlines })
        } else {
            dispatch(commonActions.getAllAirlines());
        }
        if (airports) {
            this.setState({ airports })
        } else {
            dispatch(commonActions.getAllAirports());
        }
        if (user.AppRole === appConstants.ROLES.AIRLINE) {
            let userObj = {...user};
            let userAirline = {value: userObj.AirlineId, label: userObj.AirlineName};
            this.setState({ AirlineId: userAirline }, this.search);
        } else if (user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) {
            let userObj = {...user};
            let userLocation = {value: userObj.AirportCode, label: userObj.Location};
            this.setState({ AirportId: userLocation }, this.search);
        } else if (user.Location) {
            let userObj = {...user};
            let userLocation = {value: userObj.AirportCode, label: userObj.Location};
            this.setState({ AirportId: userLocation }, this.search);
        } else {
            this.search(1);
        }

    }
    componentWillReceiveProps = function (nextProps) {
        const { airlines, airports } = nextProps;
        if (airlines) {
            let modifiedAirline = [...airlines];
            let allAirlines = {Airline: "All Airlines", AirlineId: "-1"};
            modifiedAirline.unshift(allAirlines);
            this.setState({ airlines: modifiedAirline });
        }
        if (airports) {
            let modifiedAirport = [...airports];
            modifiedAirport.unshift({Name: "All Airports",Code: "-1"});
            this.setState({ airports: modifiedAirport });
        }
    };
    handleDateChange = (date, target) => {
        this.setState({ [target]: date });
    };
    handleSelectChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleReactSelectChange = (value, name) => {
        this.setState({[name.name]: value});
        if (value.value === undefined || value.value === "-1" || value.value === "All Flights") {
            this.setState({[name.name]: "-1"})
        }
    };

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    downloadReport = (type) => {
        const { dispatch } = this.props;
        const { AirlineId, AirportId, StartDate, EndDate } = this.state;
        let payload = {
            StartDate: moment(StartDate).format('YYYY-MM-DD'),
            EndDate: moment(EndDate).format('YYYY-MM-DD'),
            Type: type
        };

        if (AirportId !== '-1')
            payload.AirportCode = AirportId.value;
        if (AirlineId !== '-1')
            payload.AirlineId = AirlineId.value;

        dispatch(alertActions.startRequest());
        commonService.downloadTokenUtilization(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    if (response.DownloadUrl) {
                        appHelpers.downloadFile(response.DownloadUrl, "Airline Token Utilization Report");
                    } else {
                        dispatch(alertActions.error(response.Message));
                    }
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response.join(', ')));
                    this.setState({ pageRequesting: false });
                }
            });
    };

    search = (pageNumber = 1) => {
        const { AirlineId, AirportId, pageSize, StartDate, EndDate } = this.state;
        const { dispatch } = this.props;

        let payload = {
            From: pageNumber, Size: pageSize,
            StartDate: moment(StartDate).format('YYYY-MM-DD'),
            EndDate: moment(EndDate).format('YYYY-MM-DD')
        };

        if (AirportId !== '-1')
            payload.AirportCode = AirportId.value;
        if (AirlineId !== '-1')
            payload.AirlineId = AirlineId.value;

        dispatch(alertActions.startRequest());
        commonService.searchTokenUtilized(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response.Entity;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    const { Reports, TotalOutstandingBillablePassengers, TotalPassengers, TotalBillablePassengers, TotalPscTokenUtilized } = response;
                    this.setState({
                        currentPage: pageNumber, pageRequesting: false,
                        records: Reports, totalCounts: response.TotalCount,
                        TotalOutstandingBillablePassengers, TotalPassengers, TotalBillablePassengers, TotalPscTokenUtilized
                    });
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({ pageRequesting: false });
                }
            });
    };

    render() {
        const { classes, requesting } = this.props;
        const { AirportId, AirlineId, airlines, airports,
            name, currentPage, pageSize, totalCounts, records,
            pageRequesting, StartDate, EndDate,
            TotalOutstandingBillablePassengers, TotalPassengers, TotalBillablePassengers, TotalPscTokenUtilized
        } = this.state;

        if (pageRequesting)
            return (
                <CircularProgress />
            );

        return (
            <div>
                <GridContainer>
                    <SearchPanel
                        user={this.props.user}
                        airports={airports}
                        airlines={airlines}
                        airline={name}
                        airport={airports}
                        selectChange={this.handleReactSelectChange}
                        handleDateChange={this.handleDateChange}
                        AirlineId={(this.props.user.AppRole === appConstants.ROLES.AIRLINE ? AirlineId : AirlineId.value)}
                        AirportId={(this.props.user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) || (this.props.user.Location) ? AirportId : AirportId.value}
                        StartDate={StartDate}
                        EndDate={EndDate}
                        onSearch={this.search}
                    />
                </GridContainer>

                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <SummaryCard
                            classes={classes}
                            passengerCount={TotalPassengers}
                            billablePax={TotalBillablePassengers}
                            outstandingPax={TotalOutstandingBillablePassengers}
                            utilizedToken={TotalPscTokenUtilized}
                        />

                    </GridItem>
                </GridContainer>

                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="success">
                                <h4 className={classes.cardTitleWhite}>
                                    Token Utilization
                </h4>
                                <p className={classes.cardCategoryWhite}>
                                    {`${totalCounts}`}
                                    {
                                        totalCounts === 1 &&
                                        ` record `
                                    }{
                                        totalCounts !== 1 &&
                                        ` records `
                                    }
                                    matched
                </p>
                            </CardHeader>
                            <CardBody>
                                {
                                    !pageRequesting && totalCounts !== 0
                                    &&
                                    <TokenUtilizationTable fetchMore={this.search} pageSize={pageSize} records={records} currentPage={currentPage} totalCounts={totalCounts} />
                                }
                                {
                                    !pageRequesting && totalCounts === 0
                                    &&
                                    <EmptyRecord message={'No record found!'} />

                                }
                            </CardBody>
                            {
                                !pageRequesting && totalCounts !== 0 &&
                                <CardFooter chart>
                                    <div>
                                        <Button type="button" color="info" onClick={() => this.downloadReport("pdf")} disabled={requesting}>
                                            <DownloadIcon />
                                            Download PDF
                                    </Button>
                                        <Button type="button" color="primary" onClick={() => this.downloadReport("excel")} disabled={requesting}>
                                            <DownloadIcon />
                                            Download EXCEL
                                    </Button>
                                    </div>
                                </CardFooter>
                            }
                        </Card>
                    </GridItem>
                </GridContainer>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const { alert, airlines, airports, user, requesting } = state;
    return {
        alert,
        airlines,
        airports,
        user,
        requesting
    };
}
export default connect(mapStateToProps)(withMobileDialog()(withStyles(dashboardStyle)(PSCUtilization)));



// WEBPACK FOOTER //
// ./src/views/PSCUtilization/Index.jsx